import React, { ChangeEvent } from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'

interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> {
  value: boolean | undefined
  update: (value: boolean) => void
  labelText?: string
  labelIcon?: JSX.Element | boolean | null
  directionRow?: boolean
  helpMessage?: string
  skipTranslation?: boolean
  inverse?: boolean
  itemStyles?: React.CSSProperties
  width?: number
}

const Checkbox = ({
  value,
  update,
  labelText,
  labelIcon,
  directionRow,
  helpMessage,
  skipTranslation,
  inverse,
  itemStyles,
  width,
  ...restProps
}: CheckboxProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    update(inverse ? !e.target.checked : e.target.checked)
  }

  return (
    <OptionWrapper
      labelText={labelText}
      labelIcon={labelIcon}
      directionRow={directionRow}
      helpMessage={helpMessage}
      skipTranslation={skipTranslation}
      itemStyles={itemStyles}
      width={width}
    >
      <input
        onChange={handleChange}
        checked={inverse ? !value : value}
        type="checkbox"
        {...restProps}
      />
    </OptionWrapper>
  )
}

export default Checkbox
